import React, { useState } from 'react';
import CounselingForm from '../components/CounselingForm';
import Logo from '../components/Logo';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import SimplifiedForm from '../components/SimplifiedForm';
import BackgroundLayout from '../components/BackgroundLayout';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 2,
        y: 0,
        transition: {
            duration: 1,
            ease: "easeInOut",
        },
    },
};

const CounselingPage = () => {
    const [selectedButton, setSelectedButton] = useState(null);
    const textClass = "text-base font-bold mt-10 mb-10 text-justify text-gray-800 drop-shadow-sm uppercase"
    const [consent, setConsent] = useState(null);
    const buttonsContainer = "flex w-full space-x-4 mt-5"
    // const navigate = useNavigate();

    const location = useLocation();
    const isSimplified = location.pathname === '/test/simplified/consent';

    const componentToRender = isSimplified
        ? <SimplifiedForm />
        : <CounselingForm />;

    const handleButtonClick = (name, value) => {
        if (name === 'consent' && value === true) {
            setSelectedButton(value);
            setConsent(true);
        } else {
            window.location.href = 'https://www.instagram.com/inspiracambioac?igsh=MzQzYTY3MmVkaXk4';
        }
    };

    return (
        <BackgroundLayout className="px-8 pb-24">
            <Logo />
            {consent === null ? (
                <motion.div
                    className="w-full flex flex-col items-center justify-center lg:w-1/4"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    <motion.h1 initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, delay: 0.5 }} className='text-7xl text-center font-bold text-[#f8485e] mt-10 drop-shadow-xl'>☝🏿</motion.h1>
                    <motion.p variants={itemVariants} className={textClass}>
                        Reconozco que vengo por voluntad propia a hacerme una prueba de detección de VIH y/o de otra ITS y otorgo mi consentimiento para que se me realicen las pruebas descritas.
                    </motion.p>
                    <motion.div className={buttonsContainer} variants={containerVariants}>
                        <div className='w-1/2 flex justify-center'>
                            <motion.button
                                variants={itemVariants}
                                type="button"
                                onClick={() => handleButtonClick('consent', true)}
                                className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${selectedButton === true ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                            >
                                Sí
                            </motion.button>
                        </div>
                        <div className='w-1/2 flex justify-center'>
                            <motion.button
                                variants={itemVariants}
                                type="button"
                                onClick={() => handleButtonClick('consent', false)}
                                className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${selectedButton === false ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                            >
                                No
                            </motion.button>
                        </div>
                    </motion.div >
                </motion.div >
            ) : (
                componentToRender
            )}
        </BackgroundLayout>
    );
};

export default CounselingPage;
